import { createAction, props } from '@ngrx/store';

export const loadChannels = createAction('[Channels] Load Channels');

export const loadChannelsSuccess = createAction(
  '[Channels] Load Channels Success',
  props<{ channels: any[] }>()
);

export const loadChannelsFailure = createAction(
  '[Channels] Load Channels Failure',
  props<{ error: string }>()
);
